import { cn } from '@/lib/core';
import { Icon } from '@/components/ui/icon';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import { REGEXP_ONLY_DIGITS } from 'input-otp';

interface PinProps {
  length?: number;
  value: string;
  onChange: (value: string) => void;
  onComplete: (value: string) => void;
  error?: string;
  inputKey?: React.Key;
  autoFocus?: boolean;
}

export function Pin({
  length = 4,
  value,
  onChange,
  onComplete,
  error,
  inputKey,
  autoFocus = true,
}: PinProps) {
  return (
    <div className="flex flex-col items-center gap-4">
      <InputOTP
        key={inputKey}
        maxLength={length}
        pattern={REGEXP_ONLY_DIGITS}
        value={value}
        onChange={onChange}
        onComplete={onComplete}
        autoFocus={autoFocus}
      >
        <InputOTPGroup className="gap-2">
          {Array.from({ length }).map((_, i) => (
            <InputOTPSlot
              key={i}
              index={i}
              activeClassName={error ? 'z-10' : 'z-10 border-jncquoi-neutral-900!'}
              className={cn(
                'font-pp-neue-montreal text-jncquoi-neutral-1000 h-16 w-14 rounded-[2px]! border text-[20px] font-semibold shadow-none',
                error ? 'border-jncquoi-asia-7427c-500' : 'border-jncquoi-neutral-200'
              )}
            />
          ))}
        </InputOTPGroup>
      </InputOTP>

      {error && (
        <div role="alert" className="flex items-center gap-1">
          <Icon
            name="warning-circle"
            width={12}
            height={12}
            className="text-jncquoi-asia-7427c-500 shrink-0"
          />
          <p className="font-pp-neue-montreal text-jncquoi-asia-7427c-500 text-[12px] tracking-[0.5px]">
            {error}
          </p>
        </div>
      )}
    </div>
  );
}
